import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeProps as _normalizeProps, withCtx as _withCtx, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0
};
var _hoisted_2 = {
  class: "table-btn"
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = {
  class: "table-btn"
};
import { createIconNode } from '@/component-create/utils/common';

import { toRefs } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XTableColumn',
  props: {
    col: {
      type: Object,
      required: true
    },
    tableData: {
      type: Array,
      required: true
    }
  },
  setup: function setup(__props) {
    var prop = __props;
    var _toRefs = toRefs(prop),
      col = _toRefs.col,
      tableData = _toRefs.tableData;
    /**
     * 获取操作列配置
     * @param fn 操作列方法
     * @param row 行数据
     * @param column 列
     * @param index 列索引
     */
    function getControllerConfig(fn, row, column, index) {
      return fn(row, column, index);
    }
    /**
     * 创建VNode节点
     */
    function createVNode(fn, row, column, index) {
      return fn(row, column, index);
    }
    /**
     * 创建header VNode节点
     */
    function createHeaderVNode(fn) {
      return fn();
    }
    return function (_ctx, _cache) {
      var _component_XTableColumn = _resolveComponent("XTableColumn", true);
      var _component_el_table_column = _resolveComponent("el-table-column");
      var _component_el_link = _resolveComponent("el-link");
      return _unref(col).group && !_unref(col).slot ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
        key: 0
      }, _unref(col))), {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(col).group, function (item, index) {
            return _openBlock(), _createBlock(_component_XTableColumn, {
              key: index,
              col: item,
              "table-data": _unref(tableData)
            }, null, 8, ["col", "table-data"]);
          }), 128))];
        }),
        _: 1
      }, 16)) : _unref(col).group ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
        key: 1
      }, _unref(col))), {
        header: _withCtx(function () {
          return [typeof _unref(col).slot === 'string' ? _renderSlot(_ctx.$slots, _unref(col).slot, {
            key: 0
          }) : (_openBlock(), _createBlock(_resolveDynamicComponent(createHeaderVNode(_unref(col).slot)), {
            key: 1
          }))];
        }),
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(col).group, function (item, index) {
            return _openBlock(), _createBlock(_component_XTableColumn, {
              key: index,
              col: item,
              "table-data": _unref(tableData)
            }, null, 8, ["col", "table-data"]);
          }), 128))];
        }),
        _: 3
      }, 16)) : _unref(col).controller && _unref(col).controller.length > 0 ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
        key: 2
      }, _unref(col))), {
        default: _withCtx(function (_ref) {
          var row = _ref.row,
            column = _ref.column,
            $index = _ref.$index;
          return [typeof _unref(col).controller === 'function' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getControllerConfig(_unref(col).controller, row, column, $index), function (item, cindex) {
            return _openBlock(), _createBlock(_component_el_link, {
              key: cindex,
              underline: false,
              type: "primary",
              class: _normalizeClass({
                'not-first': cindex !== 0
              }),
              onClick: function onClick($event) {
                return item.handler(row, _unref(tableData));
              }
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_2, [item.icon ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(createIconNode)(item.icon)), {
                  key: 0,
                  class: "table-btn-icon"
                })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.text), 1)])];
              }),
              _: 2
            }, 1032, ["class", "onClick"]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(col).controller, function (ctr, cindex) {
            return _openBlock(), _createBlock(_component_el_link, {
              underline: false,
              key: cindex,
              type: "primary",
              class: _normalizeClass({
                'not-first': cindex !== 0
              }),
              onClick: function onClick($event) {
                return ctr.handler(row, _unref(tableData));
              }
            }, {
              default: _withCtx(function () {
                return [_createElementVNode("div", _hoisted_4, [ctr.icon ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(createIconNode)(ctr.icon)), {
                  key: 0,
                  class: "table-btn-icon"
                })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(ctr.text), 1)])];
              }),
              _: 2
            }, 1032, ["class", "onClick"]);
          }), 128))]))];
        }),
        _: 1
      }, 16)) : typeof _unref(col).slot === 'string' ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
        key: 3
      }, _unref(col))), {
        default: _withCtx(function (_ref2) {
          var row = _ref2.row,
            column = _ref2.column,
            $index = _ref2.$index;
          return [_renderSlot(_ctx.$slots, _unref(col).slot, {
            row: row,
            column: column,
            index: $index
          })];
        }),
        _: 3
      }, 16)) : _unref(col).slot ? (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
        key: 4
      }, _unref(col))), {
        default: _withCtx(function (_ref3) {
          var row = _ref3.row,
            column = _ref3.column,
            $index = _ref3.$index;
          return [(_openBlock(), _createBlock(_resolveDynamicComponent(createVNode(_unref(col).slot, row, column, $index))))];
        }),
        _: 1
      }, 16)) : (_openBlock(), _createBlock(_component_el_table_column, _normalizeProps(_mergeProps({
        key: 5
      }, _unref(col))), null, 16));
    };
  }
});